import { create } from 'zustand';

type UIState = {
  headerVisible: boolean;
  setHeaderVisible: (visible: boolean) => void;
};

export const useUIStore = create<UIState>((set) => ({
  headerVisible: true,
  setHeaderVisible: (visible) => set({ headerVisible: visible }),
}));






